import {create} from 'zustand'
import {useShallow} from 'zustand/shallow'
import {devtools} from 'zustand/middleware'

import createUserSlice, {UserSlice} from './user.slices'
import createAccessesSlice, {AccessSlice} from './access.slices'
import createSubSectorSlice, {SubSectorSlice} from './subSector.slices'
import createSwitchesSlice, {SwitchesSlice} from './switch.slices'
import * as ui from './ui.slice'
import createProtectionZoneSlice, {
  ProtectionZoneSlice,
} from './protectionZone.slices'
import createGeoMarkerSlice, {GeoMarkerSlice} from './geoMarker.slices'
import createPermissionSlice, {PermissionSlice} from './permission.slices'

type StoreType = UserSlice &
  AccessSlice &
  SubSectorSlice &
  SwitchesSlice &
  ProtectionZoneSlice &
  GeoMarkerSlice &
  PermissionSlice

const useAppStore = create<StoreType>()((...a) => ({
  ...createUserSlice(...a),
  ...createAccessesSlice(...a),
  ...createSubSectorSlice(...a),
  ...createSwitchesSlice(...a),
  ...createProtectionZoneSlice(...a),
  ...createGeoMarkerSlice(...a),
  ...createPermissionSlice(...a),
}))

const useAppStoreShallow = <T>(selector: (state: StoreType) => T) =>
  useAppStore(useShallow(selector))

// Wrap the base store with devtools
export const useUIStore = devtools(ui.useUIStoreBase, {name: 'UI Store'})

// Re-export everything from ui.slice
export const {
  useWeekNavigation,
  useDayNavigation,
  useSelectedDate,
  useViewMode,
  useCurrentShift,
  useSelectedTrack,
  useShowZEP,
  useTeamIdsVisible,
  useStatusesVisible,
  useOnlyActiveZones,
  useZoneKindFilter,
  useSelectedTrackIds,
  useWorkTrackIds,
  useWorkTrackProjectId,
  useSelectedSectorIds,
  useLinearWindowOverride,
  useSynopticTypeId,
  useSynopticZoneKind,
  useSynopticGranularity,
  useSynopticTrackIds,
  useSynopticTrackNetworkId,
  useSelectedProtectionModeIds,
  useSelectedActivityTypeIds,
  useEntryFilter,
  useSelectedRequestorIds,
  useSelectedHolderIds,
  useSelectedReportOutcomes,
  useReportTodoOnly,
  useSelectedResourceRoleIds,
  useSelectedResourceLocations,
  useListDateMode,
  useListPeriod,
  useUIActions,
} = ui

// Re-export the dashboard filter store (independent persisted set)
export {
  useDashboardStore,
  useDashboardPeriod,
  useDashboardTeamIds,
  useDashboardActivityTypeIds,
  useDashboardStatuses,
  useDashboardShift,
  useDashboardActions,
} from './dashboard.slice'

export {useAppStoreShallow}

export default useAppStore
